/* Free Swatches July 2026 */
document.addEventListener('DOMContentLoaded', () => {
  const dataElement = document.querySelector(
    '#free-swatch-data'
  );

  if (!dataElement) return;

  const swatchWrapper = document.querySelector(
    '.OrderFreeSwatchWrapper'
  );

  if (!swatchWrapper) return;

  const swatchData = JSON.parse(
    dataElement.textContent
  );

  const button = swatchWrapper.querySelector(
    '.OrderFreeSwatch'
  );

  const infoWrapper = swatchWrapper.querySelector(
    '.OrderFreeSwatchInfoWrapper'
  );

  const infoIcon = swatchWrapper.querySelector(
    '.OrderFreeSwatchInfoIcon'
  );

  const infoClose = swatchWrapper.querySelector(
    '.OrderFreeSwatchInfoClose'
  );

  const infoBackdrop = swatchWrapper.querySelector(
    '.OrderFreeSwatchInfoBackdrop'
  );

  button.addEventListener('click', async () => {
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: swatchData.variantId,
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error(
          'Failed to add free swatch'
        );
      }

      button.textContent = '✓ Swatch added';

      button.classList.add('is-added');

      window.SLIDECART_UPDATE(() => {
        window.SLIDECART_OPEN();
      });

    } catch (error) {
      console.error(
        'Could not add free swatch:',
        error
      );

      button.disabled = false;

      button.textContent =
        'Order a free swatch';
    }
  });

  infoIcon.addEventListener('click', () => {
    if (
      window.matchMedia(
        '(max-width: 749px)'
      ).matches
    ) {
      infoWrapper.classList.add(
        'is-open'
      );
    }
  });

  infoClose.addEventListener('click', () => {
    infoWrapper.classList.remove(
      'is-open'
    );
  });

  infoBackdrop.addEventListener('click', () => {
    infoWrapper.classList.remove(
      'is-open'
    );
  });

  swatchWrapper
    .querySelector(
      '.OrderFreeSwatchInfoBox'
    )
    .addEventListener(
      'click',
      event => {
        event.stopPropagation();
      }
    );
});


/* Custom BIS estimate message */
(function () {
  const estimateBox = document.getElementById('product-estimated-stock');
  if (!estimateBox) return;

  const estimateText = estimateBox.querySelector('.ProductEstimatedStock__Text');
  const variantDateMap = window.variantDateMap || {};

  function updateEstimatedStock() {
    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!variantInput) return;

    const variantData = variantDateMap[variantInput.value];

    const date = variantData?.date;

    if (!date || date.trim().toLowerCase() === 'not restocking') {
      estimateBox.style.display = 'none';
      return;
    }

    estimateText.innerHTML = `Estimated back in stock: <strong>${date}</strong>`;
    estimateBox.style.display = 'block';

    estimateText.innerHTML = `Estimated back in stock: <strong>${variantData.date}</strong>`;
    estimateBox.style.display = 'block';
  }

  updateEstimatedStock();

  const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');

  if (variantInput) {
    const observer = new MutationObserver(updateEstimatedStock);

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('form[action*="/cart/add"] [name="id"]')) {
      updateEstimatedStock();
    }
  });
})();

/* Custom BIS estimate popup */
(function () {
  const overlay = document.getElementById('custom-bis-overlay');
  const form = document.getElementById('custom-bis-form');
  const variantSelect = document.getElementById('custom-bis-variant');
  const estimateBox = document.getElementById('custom-bis-estimate');
  const successBox = document.getElementById('custom-bis-success');

  if (!overlay || !form || !variantSelect) return;

  function updateEstimate() {
    const variantId = variantSelect.value.replace('$shopify:::$default:::', '');
    const date = window.variantDateMap?.[variantId]?.date;
    const emailInput = document.getElementById('custom-bis-email');
    const submitButton = form.querySelector('button[type="submit"]');
    const notRestocking = typeof date === 'string' && date.trim().toLowerCase() === 'not restocking';

    emailInput.style.display = notRestocking ? 'none' : '';
    submitButton.style.display = notRestocking ? 'none' : '';

    if (!date) {
      estimateBox.style.display = 'none';
      estimateBox.innerHTML = '';
      return;
    }

    estimateBox.style.display = 'block';
    estimateBox.innerHTML = `<span class="custom-bis-ring"></span> Estimated back in stock: <strong>${date}</strong>`;
  }

  function openModal() {
    successBox.innerHTML = '';
    successBox.removeAttribute('class');

    if (!variantSelect.options.length) {
      successBox.innerHTML = 'All variants are currently available.';
      successBox.classList.add('error');
      return;
    }

    updateEstimate();
    overlay.classList.add('active');
  }

  function closeModal() {
    overlay.classList.remove('active');
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.klaviyo-bis-trigger');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    openModal();
  }, true);

  document.querySelector('.custom-bis-close')?.addEventListener('click', closeModal);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  variantSelect.addEventListener('change', updateEstimate);

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    successBox.innerHTML = '';
    successBox.removeAttribute('class');

    const variantId = variantSelect.value;
    const rawVariantId = variantId.replace('$shopify:::$default:::', '');
    const date = window.variantDateMap?.[rawVariantId]?.date;

    if (
      typeof date === 'string' &&
      date.trim().toLowerCase() === 'not restocking'
    ) {
      successBox.innerHTML = 'This size is not being restocked.';
      successBox.classList.add('error');
      return;
    }

    const email = document.getElementById('custom-bis-email').value.trim();
    
    if (!email || !variantId) {
      successBox.innerHTML = 'Please select a size and enter an email.';
      successBox.classList.add('error');
      return;
    }

    try {
      const response = await fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=H46yBQ',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-02-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email }
                  }
                },
                channels: ['EMAIL']
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: variantId
                  }
                }
              }
            }
          })
        }
      );

      if (response.status === 202) {
        const marketingConsent = false;

        if (marketingConsent) {
          const marketingResponse = await fetch(
            'https://a.klaviyo.com/client/subscriptions/?company_id=H46yBQ',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'revision': '2024-06-15'
              },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email
                        }
                      }
                    },
                    custom_source: 'Back in Stock'
                  },
                  relationships: {
                    list: {
                      data: {
                        type: 'list',
                        id: 'QPAnNj'
                      }
                    }
                  }
                }
              })
            }
          );

          console.log('Marketing status:', marketingResponse.status);
          console.log('Marketing response:', await marketingResponse.text()); 

          if (marketingResponse.status !== 202) {
            console.error('Marketing subscription failed:', marketingResponse.status);
          }
        }

        successBox.innerHTML = "We'll let you know when it's available.";
        successBox.classList.add('success');
        form.reset();
        updateEstimate();
        return;
      }

      successBox.innerHTML = `Something went wrong (${response.status}).`;
      successBox.classList.add('error');

    } catch (err) {
      console.error(err);
      successBox.innerHTML = 'Something went wrong. Please try again.';
      successBox.classList.add('error');
    }
  });
})();